import React from 'react';
import { keyBy } from 'lodash';
import { getReactionOwner, getMemberCache } from '../../../common/store/members/members-selectors';
import { getIsMobile } from '../../../common/store/base-params/base-params-selectors';
import { LikeMetadata as LikeMetadataBase } from '../../../reactions';
import { ReactionCodeValue } from '../../../reactions/constants';
import { isDefined } from '../../../ts-utils';
import { useApi } from '../../api-provider';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { useModal, LikeListModal } from '../modals';
const LikesMetadata = ({ reactionsState, commentId, config, className, t, isPending, }) => {
    var _a;
    const likeReactionState = (_a = keyBy(reactionsState.reactions, (r) => r.reactionCode)[ReactionCodeValue.LIKE]) !== null && _a !== void 0 ? _a : { identities: [], reactionCode: ReactionCodeValue.LIKE, total: 0, hasReacted: false };
    const { resourceId, hideAvatars } = useConfiguration();
    const showModal = useModal();
    const { biOpenReactionList, memberCache, isMobile } = useApi((state, actions) => ({
        biOpenReactionList: actions.biOpenReactionList,
        memberCache: getMemberCache(state),
        isMobile: getIsMobile(state),
    }));
    const displayAmount = isMobile ? 2 : 3;
    const whoLiked = likeReactionState.identities
        .map((identity) => identity.identityId)
        .filter(isDefined)
        .slice(0, displayAmount);
    const ownersWhoLiked = whoLiked.map((id) => {
        var _a, _b, _c, _d;
        const reactionOwner = getReactionOwner(memberCache, id);
        return reactionOwner.type === 'ANONYMOUS'
            ? reactionOwner
            : {
                identityId: reactionOwner.member.id,
                type: reactionOwner.type,
                name: (_b = (_a = reactionOwner.member.profile) === null || _a === void 0 ? void 0 : _a.nickname) !== null && _b !== void 0 ? _b : undefined,
                src: (_d = (_c = reactionOwner.member.profile.photo) === null || _c === void 0 ? void 0 : _c.url) !== null && _d !== void 0 ? _d : undefined,
            };
    });
    return likeReactionState.total !== 0 ? (React.createElement(LikeMetadataBase, { className: className, displayAmount: displayAmount, whoLiked: ownersWhoLiked, totalCount: likeReactionState.total, hideAvatars: hideAvatars, isMobile: isMobile, t: t, onClick: () => {
            biOpenReactionList({ resourceId, commentId, type: 'likes' });
            showModal((toggle) => (React.createElement(LikeListModal, { toggle: toggle, totalCount: likeReactionState.total, config: config, reactions: reactionsState })));
        }, isPending: isPending })) : null;
};
export default LikesMetadata;
//# sourceMappingURL=likes-metadata.js.map